import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  keywords,
  canonicalUrl,
  ogImage = "https://customer-assets.emergentagent.com/job_affiche-display/artifacts/crzax0bb_Nettis%20transparent.png",
  ogType = "website",
  structuredData = null
}) => {
  const siteTitle = "Nettis Facility";
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} | Services de nettoyage professionnel en Belgique`;
  const baseUrl = "https://www.nettis.be";
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl || baseUrl} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl || baseUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="fr_BE" />
      <meta property="og:site_name" content={siteTitle} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
